// extracted by mini-css-extract-plugin
export var addButton = "_64-d";
export var bullets = "_64-e";
export var compact = "_64-2";
export var container = "_64-j";
export var extendedWarrantyModal = "_64-f";
export var learn = "_64-l";
export var learnMore = "_64-g";
export var offeringOption = "_64-3";
export var offeringPrice = "_64-8";
export var offeringSubtitle = "_64-7";
export var offeringTitle = "_64-6";
export var offeringsContainer = "_64-0";
export var pdpTilesBackground = "_64-n";
export var plan = "_64-m";
export var regular = "_64-1";
export var remove = "_64-k";
export var seeDetailsIcon = "_64-i";
export var seeDetailsLink = "_64-h";
export var selectedOption = "_64-4";
export var shieldIcon = "_64-b";
export var shieldIconCompact = "_64-c";
export var subtitle = "_64-a";
export var title = "_64-9";
export var unselectedOption = "_64-5";